export enum TestCaseStatus {
    Passed = 'Passed',
    Error = 'Error',
    FailedCalculationError = 'Calculation Error',
    FailedImportError = 'Import Error',
    FailedMismatch = 'Mismatch',
    Importing = 'Importing...',
    Calculating = 'Calculating...',
    NotRun = 'Not Run',
    CancelledByUser = 'Cancelled'
}

export enum OutputReport {
    GainLoss = 0,
    Combined = 1,
    ConstructiveSales = 2,
    StraddleDetails = 3,
    Rollover = 4,
    BookToTax = 5,
    DividendDetails = 6,
    IncomeByCharacterAndCountry = 7,
    TaxableIncome = 8,
    Dividend = 9,
    Settings = 10,
    BookTaxable = 11,
    DrillDown = 12,
    RollForward = 13,
    OneToOne = 14,
    BookGL = 15
}

export enum TestCaseStatusDictionary {
    NotRun = 0,
    Importing = 1,
    Calculating = 2,
    Passed = 3,
    FailedDueToCalculationError = 4,
    FailedDueToMismatch = 5,
    FailedDueToImportError = 6,
    FailedDueToException = 7,
    CancelledByUser = 8
}

export type SanityCheckImportDialogProps = {
    visible: boolean;
    onClose: () => void;
    fetchFileUploadData: () => void;
    isEditMode?: boolean;
    jobId?: string;
    testCaseId: string;
};

export type SanityImportFormState = {
    testCaseName: string;
    settingsUrl: string;
    isActive: boolean;
    inputFile: File | null;
    clientId: string;
    jobId: string;
};

export const emptyForm: SanityImportFormState = {
    testCaseName: '',
    settingsUrl: '',
    isActive: true,
    inputFile: null,
    clientId: '',
    jobId: '',
};

export const emptyErrors = {
    testCaseName: { hasError: false, errorMessage: '' },
    inputFile: { hasError: false, errorMessage: '' },
    clientId: { hasError: false, errorMessage: '' },
    jobId: { hasError: false, errorMessage: '' },
};

export type OutputFileWithType = {
    file: File;
    outputFileType: number;
};

export type OutputFileInfo = {
    fileType: number;
    fileName: string;
};

export type TestCaseDetails = {
    testCaseName: string;
    jobId: string;
    clientId: string;
    inputFileId: number;
    inputFileName: string;
    outputFiles: OutputFileInfo[];
    settingsUrl?: string;
};